import { useQuery } from '@tanstack/react-query';
import waitlistApi from '@/features/dashboard/waitlist/api/waitlistApi.ts';
import { waitlistApiQueryKeys } from '@/features/dashboard/waitlist/api/waitlistApi.queryKeys.ts';
import { getTemporalIdForIndex } from '@/features/shared/booking/utils/temporalId.ts';
import timeUtils from '@/utils/timeUtils.ts';

const useGetWaitlistTourOptions = (
  tourId: string | undefined,
  participantBirthDate?: Date,
) => {
  return useQuery({
    queryKey: waitlistApiQueryKeys.tourOptions(
      tourId ?? '',
      timeUtils.toJavaDate(participantBirthDate!),
    ),
    queryFn: async () => {
      const options = await waitlistApi.getTourOptions(tourId!, {
        temporalId: getTemporalIdForIndex(0),
        firstName: 'firstName',
        lastName: 'lastName',
        birthDate: timeUtils.toJavaDate(participantBirthDate!),
        customValues: {},
        selectedOptions: {},
      });
      return [...options].sort((a, b) => a.orderIndex - b.orderIndex);
    },
    enabled: !!tourId && !!participantBirthDate,
    staleTime: 0,
  });
};

export default useGetWaitlistTourOptions;
